var AwsAmplifyConfig = {
    Auth: {
        // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
        //identityPoolId: 'us-east-1:d8152b06-aae7-4ee7-9999-b055aff2a4e1',
        identityPoolId: 'us-east-1:70f33f97-af35-431a-a552-de7f95e1f3e0',

        // REQUIRED - Amazon Cognito Region
        region: 'us-east-1',
        //userPoolId: 'us-east-1_NL4BNOtLZ',
        userPoolId: 'us-east-1_BTkKuZt9t',

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        //userPoolWebClientId: '35q638lu6rqhug5rdht8kdcep9'
        userPoolWebClientId: '4hhttb11p5c2j8vrupprb95fdl'
    }
};

export default AwsAmplifyConfig;



// WEBPACK FOOTER //
// ./src/components/AwsAmplifyConfig.js